import { Controller } from 'stimulus';

class AdUnitHoverController extends Controller {
  static values = {
    anchor: String,
    position: String,
    adjust: Number
  }

  connect() {
    setTimeout(() => {
      this.updateHoverBox();
    }, 5000);

  }

  updateHoverBox = () => {
    let position = this.positionValue;
    let anchorElement = document.getElementById(this.anchorValue);
    let anchorRect = anchorElement.getBoundingClientRect();
    let anchorTop  = anchorRect[position];

    let rect = this.element.getBoundingClientRect();

    let marginBottom = anchorTop - rect.bottom + 1000

    if (this.hasAdjustValue) {
      marginBottom = marginBottom - this.adjustValue;
    }

    this.element.style.marginBottom = `${-1 * marginBottom}px`;
  }
}

export default AdUnitHoverController;